export default (
  state = {
    pipelineOpportunitiesData: [],
    opportunitiesList: [],
    accounts: [],
    opportunitiesByAccount: [],
    allPriceLists: [],
    isLoading: true,
  },
  action,
) => {
  switch (action.type) {
    /*
    ===============================
        Pipeline Opportunities Data
    ===============================
    */
    case "LOAD_PRICELISTS":
      return { ...state, allPriceLists: action.payload };
    /*
    ===============================
        Opportunities Details Page
    ===============================
    */
    /*
    ===============================
        Opportunities Misc
    ===============================
    */
    case "ACCOUNTS_BY_USER":
      return { ...state, accounts: action.payload };
    case "OPPORTUNITIES_BY_ACCOUNT":
      return { ...state, opportunitiesByAccount: action.payload };
    // case "COLUMN_META_DATA":
    //   return {
    //     ...state,
    //     dealTableMetaData: action.payload.parsedData,
    //     raw: { ...state.raw, dealTable: action.payload.rawData }, // This method will add a new key/value to the object
    //   };

    default:
      return state;
  }
};
